import HeaderLogo from '../../components/HeaderLogo';

export default function SpaceMaterial() {
  return <HeaderLogo shortName="material" />;
}
